<!-- <div *ngIf="isLoading == true" class="overlay">
    <div class="spinner-border"></div>
</div> -->
<div  *ngIf="isLoading == true" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>